import type { FC } from "react";

import DomPurify from "isomorphic-dompurify";

import styles from "./ReferralPersonalCode.module.scss";

const { sanitize } = DomPurify;

export interface ReferralPersonalCodeSmallTextPropsType {
  isWithBackgroundImageVariant: boolean;
  smallText?: string;
}

export const ReferralPersonalCodeSmallText: FC<ReferralPersonalCodeSmallTextPropsType> = ({
  isWithBackgroundImageVariant,
  smallText,
}) => {
  if (!smallText || !isWithBackgroundImageVariant) {
    return null;
  }

  return (
    <div
      data-testid={"referral-personal-code__small-text"}
      className={styles.smallText}
      dangerouslySetInnerHTML={{
        __html: sanitize(smallText),
      }}
    />
  );
};
